<template>
  <v-breadcrumbs :items="crumbs">
    <template v-slot:item="props">
      <router-link
        :to="props.item.to"
        :class="[props.item.disabled && 'disabled']"
        >{{ props.item.text.toUpperCase() }}</router-link
      >
    </template>
  </v-breadcrumbs>
</template>

<style scoped>
.disabled {
  color: grey;
  pointer-events: none;
}
</style>

<script>
export default {
  computed: {
    crumbs: function() {
      return this.$route.meta.breadCrumbs;
    }
  }
};
</script>
